export default "__VITE_ASSET__B55O9rZj__"